Ext.ns('mx.comp.dispatching');

mx.comp.dispatching.ShowOnMapColumn = Ext.extend(mx.comp.CheckAllColumn, {
    header: '&#160;',
    dataIndex: 'show',
    width: 24,
    sortable: false,
    resizable: false,
    hideable: false,
    fixed: true,
    menuDisabled: true,
    customCls: 'maxoptra-comp-dispatching-showonmapcolumn',
    tooltip: 'Show on map',
});
